import { Prompt } from "@models/prompt.model";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const summaryPromptsActions = createActionGroup({
    source: 'AI Insights Summary Prompts',
    events: {
        'Load Prompts': emptyProps(),
        'Loaded Prompts': props<{ summaryPrompts: Prompt[] }>()
    },
});
